<template>
	<div class="d-flex j-center">
		<div class="content-box">
			<div class="content-left-box">
				<div class="d-flex a-center" style="box-sizing: border-box;height: 5rem;padding: 1rem;color: #000000;font-weight: 600;">
					签到活动二维码
				</div>
				<div style="height: 50rem;box-sizing: border-box;width: 100%;padding:0 1.5rem;" class="list-boxs">
					<div v-for="(item,index) in cooperate_list" :key="index" style="cursor: pointer;box-sizing: border-box;border-bottom: 1px solid #E6E9ED;padding-bottom: 0.625rem;">
						<div style="color: #888888;font-size: 0.75rem;font-weight: 600;padding-bottom: 0.625rem;">{{item.add_time}}</div>
						<div class="d-flex" style="box-sizing: border-box;">
							<div style="width: 6.25rem;height: 6.25rem;border-radius: 0.5rem;">
								<img :src="item.qr_code" style="width: 6.25rem;height: 6.25rem;border-radius: 0.5rem;" alt="">
							</div>
							<div style="flex: 1;height: 6.25rem;color: #000000;font-size: 12px;font-weight: 600;margin-left: 1rem;" class="d-flex flex-column j-sb">
								<div class="" style="">
									{{item.qr_type==0?'匿名签到（只用于统计人数）':'实名签到（填写信息统计）'}}
								</div>
								<div @click="download(item.qr_code,item.qr_type)"
								style="width: 4.5rem;height: 1.5rem;background-color: #DDDDDD;border-radius: 2px;color: #888888;font-size: 0.75rem;color: #888888;font-size: 12px;" 
									 class="d-flex a-center j-center">
									下载二维码
								</div>
								<div style="width: 100%;box-sizing: border-box;color: #1E69FF;font-size: 0.75rem;" class="d-flex a-center j-sb">
									<div @click.stop="watchDetail(item,index)">签到详情</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="content-right-box">
				<div class="d-flex a-center j-sb" style="box-sizing: border-box;height: 5rem;padding: 1rem;color: #000000;font-weight: 600;">
					<div>{{paramData.qr_type==0?'匿名签到':'实名签到'}}</div>
					<div class="d-flex a-center" style="box-sizing: border-box;">
						<el-button type="primary" size="mini" @click="getData(0)" :class="type==0?'all-active':'all'"
						style="width: 3.75rem;margin-right: 1.5rem;">全部</el-button>
						<el-button type="primary" size="mini" @click="getData(1)" :class="type==1?'all-active':'all'"
						style="width: 3.75rem;margin-right: 1.5rem;">今日</el-button>
						<div>
							 <el-date-picker
								v-model="value1"
								type="daterange"
								range-separator="至"
								start-placeholder="开始日期"
								end-placeholder="结束日期"
								size="mini"
								style="width: 20rem;"
								value-format="yyyy-MM-dd"
								@change="selDate">
							</el-date-picker>
						</div>
					</div>
				</div>
				<div class="d-flex a-center" style="box-sizing: border-box;color: #000000;font-size: 0.875rem;font-weight: 600;border-bottom: 1px solid #E6E9ED;padding: 1rem; padding-top: 0;">
					<div class="d-flex" style="margin-right: 8.125rem;">
						总签到人数：<div style="margin-left: 1.375rem;">{{count_num}}人</div>
					</div>
					<div class="d-flex" style="margin-right: 8.125rem;">
						当日签到人数：<div style="margin-left: 1.375rem;">{{today_num}}人</div>
					</div>
					<div class="d-flex">
						时间段签到人数：<div style="margin-left: 1.375rem;">{{time_num}}人</div>
					</div>
				</div>
				<div class="on_sale_table">
					<div class="table" >
						<el-table ref="multipleTable" :height="880" :border="false" :data="tableData" tooltip-effect="dark"
							style="font-size: 0.75rem;border-radius: 0.375rem 0.375rem 0 0;" :header-cell-style="{color:'#000000'}">
							<el-table-column align="center" prop="id" label="编号" show-overflow-tooltip>
							</el-table-column>
							<template v-if="paramData.qr_type==0">
								<el-table-column align="center" prop="user_logo" label="微信头像" show-overflow-tooltip>
									<template slot-scope="scope">
										<img :src="scope.row.user_logo" style="width: 1.5rem;height: 1.5rem;border-radius: 50%;" alt="">
									</template>
								</el-table-column>
								<el-table-column align="center" prop="nick_name" label="微信昵称" show-overflow-tooltip>
								</el-table-column>
							</template>
							<template v-else>
								<el-table-column align="center" prop="name" label="称呼" show-overflow-tooltip>
									<template slot-scope="scope">
										<div>{{scope.row.name}}</div>
									</template>
								</el-table-column>
								<el-table-column align="center" prop="mobile" label="电话" show-overflow-tooltip>
								</el-table-column>
								<el-table-column align="center" prop="business_name" label="公司名称" show-overflow-tooltip>
									<template slot-scope="scope">
										{{scope.row.business_name != ''?scope.row.business_name:'/'}}
									</template>
								</el-table-column>
							</template>
							<el-table-column align="center" prop="add_time" label="签到时间" show-overflow-tooltip>
							</el-table-column>
						</el-table>
						<footer class="d-flex j-sb a-center">
							<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
								:current-page.sync="currentPage" :page-size="pageSize" layout="prev, pager, next, total" :total="total_records">
							</el-pagination>
						</footer>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				paramData:{
					qr_code:'',
					qr_type:0
				},
				cooperate_list:[],
				tableData:[],
				currentPage: 1, //初始页
				pageSize : 10,
				total_records : 0,
				value1:'',
				start_time:'',
				end_time:'',
				type:0,
				count_num:0,
				today_num:0,
				time_num:0
			}
		},
		methods:{
			admin_get_business_sign_qr_code(){
				let params = {
					act:'admin_get_business_sign_qr_code',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id')
				}
				this.$api.admin_get_business_sign_qr_code(params).then((res)=>{
					this.cooperate_list = res.data
				})
			},
			admin_get_business_sign_num(){
				let params = {
					act:'admin_get_business_sign_num',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id')
				}
				this.$api.admin_get_business_sign_num(params).then((res)=>{
					this.count_num=res.data.count_num
					this.today_num=res.data.today_num
				})
			},
			admin_get_business_sign_info(){
				let params = {
					act:'admin_get_business_sign_info',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					sign_type:this.paramData.qr_type,
					type:this.type,
					start_time:this.start_time,
					end_time:this.end_time,
					page:this.currentPage,
					size:this.pageSize,
				}
				this.$api.admin_get_business_sign_info(params).then((res)=>{
					this.tableData=[]
					this.total_records=0
					this.time_num=0
					if(res.code==0){
						this.tableData = res.data
						this.total_records=res.total_records
						if(this.type==2){
							this.time_num=this.total_records
						}
					}
				})
			},
			download(href, type) {
				let eleLink = document.createElement('a')
				eleLink.download = type==0?'匿名':'实名'
				eleLink.href = href
				eleLink.target = '_blank'
				eleLink.click()
				eleLink.remove()
			},
			handleSizeChange(size) {
				this.pageSize = size;
			},
			handleCurrentChange(currentPage) {
				this.currentPage = currentPage;
				this.admin_get_business_sign_info()
			},
			watchDetail(item,index){
				this.paramData = item
				console.log(item);
				this.sign_type = item.qr_type
				this.admin_get_business_sign_info()
			},
			getData(num){
				this.type=num
				this.start_time=''
				this.end_time=''
				this.value1=''
				this.admin_get_business_sign_info()
				this.admin_get_business_sign_num()
			},
			selDate(e){
				this.type=2
				this.start_time=e[0]
				this.end_time=e[1]
				this.admin_get_business_sign_info()
			}
		},
		created() {
			if(this.$route.query.coo_id){
				this.paramData=this.$route.query
			}
			this.admin_get_business_sign_qr_code()
			this.admin_get_business_sign_info()
			this.admin_get_business_sign_num()
		}
	}
</script>

<style scoped>
	.content-box{
		width: 85rem;
		min-height: 55rem;
		display: flex;
		justify-content: space-between;
		box-sizing: border-box;
	}
	.content-left-box{
		width: 20rem;
		height: 100%;
		background: #FFFFFF;
		border-radius: 0.625rem;
		box-sizing: border-box;
		/* padding: 1.25rem; */
		font-size: 1rem;
		color: #888888;
		font-weight: 600;
	}
	.content-right-box{
		width: 64rem;
		height: 100%;
		background: #FFFFFF;
		border-radius: 0.625rem;
		box-sizing: border-box;
		padding: 0 1.5rem 1.5rem 1.5rem;
		display: flex;
		justify-content: space-between;
		flex-direction: column;
	}
	
	.avatar-uploader .el-upload {
	    border: 0.0625rem dashed #BBBBBB;
	    border-radius: 6px;
	    cursor: pointer;
	    position: relative;
	    overflow: hidden;
	}
	.avatar-uploader .el-upload:hover {
	    border-color: #409EFF;
	}
	.avatar-uploader-icon {
		border: 0.0625rem dashed #BBBBBB;
	    font-size: 28px;
	    color: #8c939d;
	    width: 7.5rem;
	    height: 11.25rem;
	    line-height: 11.25rem;
	    text-align: center;
		border-radius: 6px;
	}
	.avatar-uploader .avatar-uploader-icon:hover {
	    border-color: #409EFF;
	}
	.avatar {
	    width: 7.5rem;
	    height: 11.25rem;
		border-radius: 6px;
	    display: block;
	}
	.img-box::-webkit-scrollbar{
		  display: none;
	}
	.list-boxs::-webkit-scrollbar{
		background: #BBBBBB;
		width: 5px;
	}
	.list-boxs::-webkit-scrollbar-thumb {
		/*滚动条里面的条*/
		border-radius: 10px;
		box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		background: #BBBBBB;
		width: 5px;
	}
	
	.on_sale_table{
		width: 100%;
		box-sizing: border-box;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
	}
	.table {
		/* margin-top: 1.44rem; */
		width: 100%;
		height: 100%;
		/* background: #E6E9ED; */
		overflow: hidden;
		/* padding: 1.25rem; */
		/* border-radius: 0.375rem; */
	}
	footer {
		width: 100%;
		height: 2.5rem;
		background: #FFFFFF;
		padding: 0 1.25rem;
		box-sizing: border-box;
		justify-content: flex-end;
		/* border-radius:0 0 0.375rem 0.375rem; */
	}
	.all{
		box-sizing: border-box;
		border:1px solid #205DFF;
		color: #205DFF;
		background-color: #FFFFFF;
	}
	.all-active{
		background-color: #205DFF;
		color: #FFFFFF;
		box-sizing: border-box;
	}
</style>